var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{directives:[{name:"intersect",rawName:"v-intersect",value:(_vm.intersect),expression:"intersect"}],tag:"component"},[(_vm.componentExist)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }